import type { FileIconProps } from './FileIcon';

function FolderLockedIcon({ size = 30 }: FileIconProps) {
  return (
    <svg
      width={size}
      height={size * 1.3333333333}
      viewBox='0 0 30 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid='icon-folder-locked'>
      <path
        d='M28 4.88151C28 3.96104 27.1643 3.21484 26.1334 3.21484L22.4001 3.21484L22.4001 33.2148L23.3334 33.2148C24.8798 33.2148 26.1334 32.0956 26.1334 30.7148L26.1334 10.2982C27.1643 10.2982 28 9.55198 28 8.63151L28 4.88151Z'
        fill='#AD6A06'
      />
      <rect
        opacity='0.7'
        x='24.2663'
        y='5.71387'
        width='25'
        height='16.7997'
        rx='2'
        transform='rotate(90 24.2663 5.71387)'
        fill='#EDE3DC'
      />
      <path
        d='M20.3703 0.72137C21.4612 0.635391 22.3996 1.40987 22.3996 2.39625L22.3996 34.0334C22.3996 35.0198 21.4612 35.7943 20.3703 35.7083L2.55592 34.3043C1.10967 34.1904 3.4824e-05 33.0996 3.48812e-05 31.792L3.60682e-05 4.63766C3.61253e-05 3.33004 1.10967 2.23932 2.55592 2.12534L20.3703 0.72137Z'
        fill='#CB8D30'
      />
      <path
        d='M20.3703 0.72137C21.4612 0.635391 22.3996 1.40987 22.3996 2.39625L22.3996 34.0334C22.3996 35.0198 21.4612 35.7943 20.3703 35.7083L2.55592 34.3043C1.10967 34.1904 3.4824e-05 33.0996 3.48812e-05 31.792L3.60682e-05 4.63766C3.61253e-05 3.33004 1.10967 2.23932 2.55592 2.12534L20.3703 0.72137Z'
        fill='url(#paint0_linear_11205_28996)'
        fillOpacity='0.25'
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d='M9.09091 13.4863H17.0909M12 16.153H20M6.90909 18.8197H14.9091M4 21.4863H12'
        stroke='white'
        strokeOpacity='0.6'
        strokeWidth='1.5'
      />
      <rect x='14' y='24' width='16' height='16' rx='8' fill='#006D86' />
      <g clipPath='url(#clip0_11205_28996)'>
        <path
          d='M24.3333 31.6667H19.6667C19.2985 31.6667 19 31.9651 19 32.3333V34.6667C19 35.0348 19.2985 35.3333 19.6667 35.3333H24.3333C24.7015 35.3333 25 35.0348 25 34.6667V32.3333C25 31.9651 24.7015 31.6667 24.3333 31.6667Z'
          stroke='#DCECED'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.3333 31.6667V30.3333C20.3333 29.8913 20.5089 29.4674 20.8215 29.1548C21.134 28.8423 21.558 28.6667 22 28.6667C22.442 28.6667 22.8659 28.8423 23.1785 29.1548C23.4911 29.4674 23.6666 29.8913 23.6666 30.3333V31.6667'
          stroke='#DCECED'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_11205_28996'
          x1='16.4264'
          y1='20.0933'
          x2='16.4264'
          y2='35.5817'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#7F510B' stopOpacity='0' />
          <stop offset='1' stopColor='#7F510B' />
        </linearGradient>
        <clipPath id='clip0_11205_28996'>
          <rect width='8' height='8' fill='white' transform='translate(18 28)' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FolderLockedIcon;
